import { render, staticRenderFns } from "./provisao.vue?vue&type=template&id=5e620818&scoped=true"
import script from "./provisao.vue?vue&type=script&lang=ts"
export * from "./provisao.vue?vue&type=script&lang=ts"
import style0 from "./provisao.vue?vue&type=style&index=0&id=5e620818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e620818",
  null
  
)

export default component.exports